import { useEffect } from 'react';
import { trackClientPageview } from '../../analytics/client-event-tracking';

export function usePageviewTracking(account) {
  useEffect(() => {
    trackClientPageview(account);
  }, [account]);
}
